import { stayOptions } from "@/data/resort";
import { ResortLink } from "../resort-button";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

export function StayOptions() {
  return (
    <section
      id="stay-options"
      aria-labelledby="stay-options-heading"
      className="bg-background py-16 md:py-20"
    >
      <div className="shell">
        <Reveal>
          <Eyebrow>Stay Your Way</Eyebrow>
        </Reveal>
        <h2 id="stay-options-heading" className="display-lg mt-6 max-w-[20ch]">
          <MaskReveal>One Night, One Week</MaskReveal>
          <MaskReveal delay={0.08}>or a Little Longer</MaskReveal>
        </h2>

        <ul className="mt-10 grid gap-6 md:grid-cols-3">
          {stayOptions.map((option, i) => (
            <li key={option.id}>
              <Reveal delay={i * 0.07} className="h-full">
                <article className="flex h-full flex-col border border-border bg-card p-8 transition-all duration-500 hover:-translate-y-1 hover:shadow-soft md:p-10">
                  <h3 className="eyebrow text-primary">{option.label}</h3>
                  <p className="mt-6 flex-1 text-base leading-relaxed text-muted-foreground">
                    {option.copy}
                  </p>
                  <ResortLink variant="solid" href={option.href} className="mt-10 w-full">
                    {option.cta}
                  </ResortLink>
                </article>
              </Reveal>
            </li>
          ))}
        </ul>

        <Reveal delay={0.1}>
          <p className="mt-8 text-sm text-muted-foreground">
            Site availability and pricing may vary by stay length and site type. Monthly RV sites in
            Auburn CA are subject to availability.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
